import React, { useState, useEffect } from "react";
import flogo from "../assets/images/Grayzo_New_Logo_White1.webp";
import ProductsDropdownNav from "./ProductsDropdownNav";
import { NavLink } from "react-router-dom";
import CompanyDropdownNavbar from "./CompanyDropdownNavbar";
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".navbar")) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav
      className={`navbar sticky-top navbar-expand-lg navbar-light px-2 px-lg-0 ${scrolled ? "navbar-scrolled shadow-sm" : "py-2 py-lg-0"
        }`}
      style={{ textTransform: "uppercase", transition: "all 0.3s ease", background: '#92837c', minHeight: 70 }}
    >
      <a href="/" className="navbar-brand ms-lg-5">
        <img
          src={flogo}
          className="img-fluid"
          width={120}
          height={50}
          // style={{ height: "50px" }}
          alt="company logo"
        />
      </a>

      <button
        className="navbar-toggler"
        type="button"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      <div
        className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}
        id="navbarCollapse"
      >
        <div
          className="navbar-nav ms-auto py-0"
          style={{ textTransform: "uppercase" }}
        >
          <NavLink
            to="/"
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) =>
              `nav-item nav-link ${isActive ? "active" : ""}`
            }
          >
            Home
          </NavLink>

          <ProductsDropdownNav closeMobileMenu={() => setMenuOpen(false)} />
          <CompanyDropdownNavbar closeMobileMenu={() => setMenuOpen(false)} />

          {/* <NavLink
            to="/our-clients"
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) =>
              `nav-item nav-link ${isActive ? "active" : ""}`
            }
          >
            Clients
          </NavLink> */}
          <NavLink
            to="/contact-us"
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) =>
              `nav-item nav-link ${isActive ? "active" : ""}`
            }
          >
            Contact
          </NavLink>
        </div>
      </div>

      <div className="nav-item nav-link nav-contact text-white px-0 px-md-5 ms-lg-5">
        <div>
          <a
            className="btn btn-lg bg-white  btn-lg-square me-2"
            href="https://www.facebook.com/profile.php?id=100091982918966"
            target="_blank"
            rel="noreferrer"
            title="facebook"
          >
            <FaFacebookF style={{ color: "blue" }} size={18} />
          </a>
          <a
            className="btn btn-lg bg-white btn-lg-square me-2"
            href="https://www.instagram.com/grayzo_india/"
            target="_blank"
            rel="noreferrer"
            title="instagram"
          >
            <FaInstagram style={{ color: "#d250db" }} size={18} />
          </a>
          <a
            className="btn btn-lg bg-white btn-lg-square me-2"
            href="https://x.com/Grayzo_India"
            target="_blank"
            rel="noreferrer"
            title="twitter"
          >
            <FaXTwitter style={{ color: "black" }} size={18} />
          </a>
          <a
            className="btn btn-lg bg-white  btn-lg-square me-2"
            href="https://www.youtube.com/channel/UCvF4eJdUJuijRK138AwLAOg"
            target="_blank"
            rel="noreferrer"
            title="youtube"
          >
            <FaYoutube style={{ color: "red" }} size={18} />
          </a>
        </div>
        {/* <div class="text-center mt-2 text-dark"><span><i class="bi bi-telephone-fill me-1"></i>+91 9958222011</span></div> */}
      </div>
    </nav>
  );
}

export default Navbar;
